import { DateRange } from '../../models';
import { Component, ViewChild, Output, EventEmitter, OnInit } from '@angular/core';
import { SubmitableFormGroup } from 'ng2-material-components/ng2-material-components';
import { SheetComponent } from '../sheet/sheet.component';
import { DateRangeComponent } from '../date-range';
import * as moment from 'moment';

@Component({
    selector: 'date-range-sheet',
    template: require('./date-range-sheet.component.pug'),
})
export class DateRangeSheetComponent implements OnInit {
    @ViewChild(SheetComponent) sheetComponent;
    @ViewChild(DateRangeComponent) dateRangeComponent;

    isValid: boolean = true;
    fg = new SubmitableFormGroup({});

    @Output() applyRange = new EventEmitter<DateRange>();

    ngOnInit() {
        setTimeout(() => this.onApplyClicked(), 1000);
    }

    toggle() {
        this.sheetComponent.toggle();
    }

    onApplyClicked() {
        this.fg.submitted = true;
        let value = this.fg.value;

        let dateRange = new DateRange(
            value.from === '' ? moment() : moment(value.from),
            value.to === '' ? moment() : moment(value.to)
        );

        this.isValid = dateRange.isValid;
        if (this.isValid) {
            this.applyRange.emit(dateRange);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/date-range-sheet/date-range-sheet.component.ts